import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "./RenderByType/RenderComponents";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Tooltip} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    container: {
        width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'baseline',
        //position: 'relative',
        overflow: 'auto'
    },
    optionButton: {
        position: 'absolute',
        left: 0,
        top: 0
    }
}));
const ForEach = (props) => {
    const {component, index: parentIndex, path} = props;
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const {styles: sourceStyles, children = []} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const classes = useStyles();
    const hasChildren = children && children.length;
    const {properties: {removable, creatable} = {}} = component;

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.panel,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <div ref={drop}
             className={classes.container}
             style={{
                 padding: (creatable || removable) && '2px 0 2px 18px',
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: styles.alignItems
             }}
        >
            <OptionIcon creatable={creatable} removable={removable}/>
            <RenderChildren
                hasChildren={hasChildren}
                children={children}
                path={path}
                isOverCurrent={isOverCurrent}
            />
        </div>
    )
};
export default ForEach;

ForEach.propTypes = {
    component: PropTypes.object,
    parentPath: PropTypes.string,
    path: PropTypes.string,
    index: PropTypes.number
};


const RenderChildren = ({hasChildren, isOverCurrent, children, path}) => {
    return (
        hasChildren ? (
            children.map((item, index) => {
                return (
                    <RenderComponents
                        key={index}
                        type={item.type}
                        item={item}
                        index={index}
                        path={`${path}.children.${index}`}
                        parentPath={path}
                    />
                )
            })
        ) : (
            isOverCurrent && (
                <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                </div>
            )
        )
    )
};

const OptionIcon = ({creatable, removable}) => {
    const classes = useStyles();
    if (!creatable && !removable) return <></>;
    return (
        <Tooltip title={'Array options'}>
            <IconButton size={"small"} className={classes.optionButton}>
                <Icon fontSize={"small"}>
                    more_vert
                </Icon>
            </IconButton>
        </Tooltip>
    )
};